// Route chunk loaders, shared by React.lazy in App and the idle prefetch below.
export const loadRecipes = () => import('../views/Recipes');
export const loadRecipeDetail = () => import('../views/RecipeDetailWrapper');

/**
 * Warm the two routes nearly every visit goes on to use once the browser is
 * idle, so the first click doesn't wait on a chunk round-trip. (Repeat visits
 * already have every chunk in the service worker's precache.)
 */
export function prefetchCommonRoutes(): void {
	const run = (): void => {
		void loadRecipes();
		void loadRecipeDetail();
	};
	if ('requestIdleCallback' in window) window.requestIdleCallback(run);
	else setTimeout(run, 2000);
}
